<template>
  <div class="cassso h100 flex-box ju-c al-c">
    <div class="tx-c">
      <div class="mt20 mb20 grey font-18" v-if="errorMsg">
        登录失败:{{ errorMsg }}
      </div>
      <el-button size="large" type="primary" @click="goBack" v-if="loginError"
        >返回登录</el-button
      >
      <!-- <el-button size="large" type="primary" @click="test" >xxxxxx</el-button> -->
    </div>
  </div>
</template>

<script>
import sso from "@/server/sso";
import { mapGetters, mapActions } from "vuex";
import AddRouterFunc from "@/router/addRouter";
import { ssoLogin, getLoginConfig } from "@/api/login";
import routeData from "@/router/routerData";
import { goHomeAfterLogin } from "@/util/utils";

export default {
  name: "cassso",
  props: [],
  components: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      errorMsg: "",
      loginError: false,
    };
  },
  computed: {},
  created() {
    this.getLoginConfig();
    this.loginError = false;
  },
  mounted() {
    var ticket = this.getUrlStr("ticket");
    if (ticket) {
      this.login(ticket);
    } else {
      let setConfig = JSON.parse(window.sessionStorage.getItem("setConfig"));
      if (setConfig.isOpenCassso) {
        window.open(setConfig.ssoLogin);
      } else {
        this.$router.push("/login");
      }
    }
  },
  destroyed() {},
  methods: {
    ...mapActions([
      "setUserToken",
      "setUserData",
      "logout",
      "setAccessToken",
      "bpmnSecurityLoginHandle",
    ]),

    //获取参数
    getUrlStr(name) {
      var url = document.location.toString();
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == name) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    goBack() {
      let setConfig = JSON.parse(window.sessionStorage.getItem("setConfig"));
      if (setConfig.isOpenCassso) {
        window.open(setConfig.ajaxLogout);
      } else {
        this.$router.push("/login");
      }
    },
    bpmLogin(username) {
      return new Promise((resolve, reject) => {
        this.bpmnSecurityLoginHandle({
          userName: username,
          deviceType: "pc",
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            this.$message.error("流程引擎登录失败");
            this.$store.commit("SET_ACCESS_TOKEN", null);
            sessionStorage.removeItem("nz_access_token");
            reject();
          });
      });
    },
    login(ticket) {
      ssoLogin(ticket)
        .then(async res => {
          if ("access_token" in res.data) {
            // await this.bpmLogin(res.data.username)

            this.$store.commit("SET_ACCESS_TOKEN", res.data.access_token);
            localStorage.token = res.data.access_token;
            this.$store.commit("SET_LOG_MSG", res.data);

            window.sessionStorage.setItem(
              "nz_access_token",
              "Bearer " + res.data.access_token
            );
            // 获取组织部门树
            this.$store
              .dispatch("getDeptTree")
              .then(() => {})
              .catch(err => {});
            this.bpmnSecurityLoginHandle({
              userName: res.data.username,
              deviceType: "pc",
            }).catch(() => {
              this.$message.error("流程引擎登录失败");
              // this.$store.commit("SET_ACCESS_TOKEN", null);
              // sessionStorage.removeItem('nz_access_token')
            });
            //获取用户权限
            this.$store.dispatch("GetUserPermissions").then(res => {
              //获取个人菜单;
              let userInfo = {
                deviceType: "pc",
                // ip: '',
                // routeJur: {},
                userId: res.data.sysUser.userId,
                userImg: res.data.sysUser.avatar,
                userName: res.data.sysUser.username,
                deptId: res.data.sysUser.deptId,
                roleCodes: res.data.roleCodes,
                firstLogin: (res.data.sysUser && res.data.sysUser.firstLogin) || "",
              };
              let routerData = res.data.permissions;
              routerData = [
                ...routerData,
                "/office",
                "/test",
                "/statistical/all",
                "/ServeCenterDetail",
                "/notifyDetail",
                "/serveEvaluate",
                "/search",
                "/noticesAndFilesPagination",
                "/fileDetail",
                "/teacherTimetable",
                "/staff",
                "/jobshire",
                "/annualappraisal",
                "/wage",
                "/classroomQuery",
              ];
              if ((res.data.roleCodes || []).includes("ROLE_ADMIN")) {
                routerData = [];
                const routeHandler = function (arr) {
                  for (let i = 0; i < arr.length; i++) {
                    routerData.push(arr[i].path);
                    if (arr[i].children) {
                      routeHandler(arr[i].children);
                    }
                  }
                };
                routeHandler(routeData);
                routerData = routerData.concat([
                  "system-management",
                  "business-management",
                  "advices-management",
                  "efficiency-management",
                  "data-management",
                ]);
              }
              // routerData = ["/test","/accrualBasis","/serveEvaluate","/serveCenter","/addAdvice","/office","/mine","/management","/statistical","/statistical/all","/mine/userData","/mine/passwordEdit","/mine/message","/mine/collect","/mine/myAffair","/management/serve","/management/app","/management/theme","/management/user","/management/depManage","/management/tool","/management/flow","/management/complain","/management/search","/management/desktop","/management/homeCard","/management/file", "/management/QAHelper","/management/roleManage", '/management/special','/management/rightsli',"/management/reportManage","/management/policyFile","/mine/suggest","/mine/voiceMessage","/management/score","/management/navlink","/ServeCenterDetail","/management/advices","/management/showcase","/management/job","/management/label","/management/notification","/notifyDetail","/QAHelper", "/search","/noticesAndFilesPagination","/fileDetail",]  //暂时写死

              this.setUserData({
                ...userInfo,
                routerData,
              });

              localStorage.setItem(
                "userData",
                JSON.stringify({
                  ...userInfo,
                  routerData,
                })
              );

              sessionStorage.setItem("loginFrom", "cassso");

              this.logining = false;

              const routers = AddRouterFunc.getNewRouerData(routerData);
              this.$router.addRoutes(routers);

              goHomeAfterLogin(this, userInfo.firstLogin, "/office");
            });
          } else {
            this.$message.error(res.data.msg || "登录出错");
            this.errorMsg = res.data.msg || "";
            this.loginError = true;
          }
        })
        .catch(err => {
          this.$message.error(err || "登录出错");
          this.loginError = true;
        });
    },
    async getLoginConfig() {
      let res = await getLoginConfig();
      res.data.data.isOpenCassso == "1"
        ? (res.data.data.isOpenCassso = true)
        : (res.data.data.isOpenCassso = false);
      res.data.data.middlePage == "1"
        ? (res.data.data.middlePage = true)
        : (res.data.data.middlePage = false);
      res.data.data.phone == "1"
        ? (res.data.data.phone = true)
        : (res.data.data.phone = false);
      res.data.data.mobileOrPc == "1"
        ? (res.data.data.mobileOrPc = true)
        : (res.data.data.mobileOrPc = false);
      window.sessionStorage.setItem("setConfig", JSON.stringify(res.data.data));
      let faviconLink = document.querySelector("#faviconLink");
      if (faviconLink) {
        faviconLink.setAttribute("href", res.data.data.favicon);
      }
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less"></style>
